module.exports = __webpack_public_path__ + "img/bg-head.34836314.webp";